<template>
  <div class="fileInput">
    <div v-if="defaultValue||value" :style="{backgroundImage: `url(.${defaultValue})`}" @click="del"/>
    <label for="file" v-else title="點擊上傳圖片" :style="[fontSize ? { fontSize } : {}, bg ? {backgroundColor:bg} : {}]">
      <input type="file" id="file" name="file" :accept="accept" @change="upload" :disabled="disabled">
      {{text || '上傳'}}
    </label>
  </div>

</template>

<script>
export default {
  name: 'FileInput',
  props: ['defaultValue', 'folder', 'disabled', 'fontSize', 'accept', 'text', 'bg'],
  data () {
    return {
      value: null
    }
  },
  methods: {
    del () {
      if (!this.disabled) {
        this.$emit('input', null)
      }
    },
    async upload (ev) {
      if (ev.target.files[0]) {
        const image = await this.$store.dispatch('uploadFile', { event: ev, folder: this.folder })
        if (image) {
          this.$emit('input', `/${this.folder}/${image.filename}`)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fileInput {
  width: 100%;
  height: 100%;
  &>div{
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
label {
  width: 100%;
  height: 100%;
  background-color: transparent;
  input[type=file] {
    display: none;
  }
  font-size: 12px;
  line-height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-border);
  color: #FFFFFF;
  border-radius: 3px;
}
</style>
